import React, { useState } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled, { css } from "styled-components/macro"; //eslint-disable-line
import { Container, ContentWithPadding } from "components/misc/Layouts.js";
import { SectionHeading } from "components/misc/Headings.js";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const PrimaryBackgroundContainer = tw(Container)`-mx-8 bg-primary-900 text-gray-100`;

const HeadingContainer = tw.div``;
const Heading = tw(SectionHeading)``;

const FaqsContainer = tw.div`
  mt-6 sm:mt-10 lg:mt-16
  w-full
  flex-1
  px-4 sm:px-6 lg:px-0
  lg:flex
  justify-between
  items-start
  max-w-screen-lg
  mx-auto
`;

const FaqsColumn = tw.div`
  w-full
  mb-8 lg:mb-0
  lg:max-w-lg
  lg:mr-12
  last:mr-0
`;

const Faq = tw.div`
  select-none
  cursor-pointer
  border-b-2
  border-primary-300
  hover:border-primary-500
  active:border-primary-600
  transition-colors
  duration-300
  py-4 sm:py-5 lg:py-6
  -mx-2 px-2 sm:mx-0 sm:px-0
  rounded-lg sm:rounded-none
  hover:bg-gray-500 hover:bg-opacity-5 sm:hover:bg-transparent
  touch-manipulation
`;

const Question = tw.div`
  flex
  justify-between
  items-center
  min-h-[44px]
`;

const QuestionText = tw.div`
  text-base sm:text-lg lg:text-xl
  font-semibold
  tracking-wide
  leading-6 sm:leading-7
  pr-4
  text-left
`;

const QuestionToggleIcon = styled(motion.span)`
  ${tw`
    ml-2 sm:ml-3
    transition
    duration-300
    flex-shrink-0
    p-1
    -mr-1
  `}
  svg {
    ${tw`w-5 h-5 sm:w-6 sm:h-6`}
  }
`;

const Answer = tw(motion.div)`
  hidden
  text-sm sm:text-base
  font-normal
  mt-3 sm:mt-4
  text-gray-300
  leading-6 sm:leading-7
  pr-8 sm:pr-12
`;

export default ({
  heading = "Frequently Asked Questions",
  faqs = [
    {
      question: "How do i register on this website?",
      answer:
        "Please send an email to president.agcoa@gmail.com with you gmail Id which you will use to login, along with your name and plot number. We will send a welcome email once we onboard you."
    },
    {
      question: "What are the monthly HOA dues?",
      answer:
        "Monthly HOA dues vary based on your property type and amenities included. Standard dues cover common area maintenance, and community amenities. Contact the HOA office for current rates specific to your property."
    },
    {
      question: "What are the community amenities?",
      answer:
        "Our community features a clubhouse with fitness center, swimming pool, 2 parks, and walking trails. Note: all amenities except parks are in proposed status only."
    },
    {
      question: "How do I report a maintenance issue?",
      answer:
        "For common area maintenance issues, contact the HOA management directly through our online portal or by phone."
    },
    {
      question: "What are the parking and vehicle policies?",
      answer:
        "As long as you don't create issues for others, we are pretty cool about where you park your vehicles. Ideally please plan for parking, before constructing your house 😁."
    },
    {
      question: "Where can I find the community rules and regulations?",
      answer:
        "The complete CC&Rs (Covenants, Conditions & Restrictions), bylaws, and community rules are available on this website (after login). You will have to be registered to make use of the said features on this website. Updated rules are communicated via newsletters and community notices on this website."
    }
  ]
}) => {
  const faqCol1 = [];
  const faqCol2 = [];
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(null);

  const toggleQuestion = questionIndex => {
    if (activeQuestionIndex === questionIndex) setActiveQuestionIndex(null);
    else setActiveQuestionIndex(questionIndex);
  };

  faqs.map((faq, index) => {
    const renderedFaq = (
      <Faq key={index} onClick={() => toggleQuestion(index)}>
        <Question>
          <QuestionText>{faq.question}</QuestionText>
          <QuestionToggleIcon
            variants={{
              collapsed: { rotate: 0 },
              open: { rotate: -180 }
            }}
            initial="collapsed"
            animate={activeQuestionIndex === index ? "open" : "collapsed"}
            transition={{ duration: 0.02, ease: [0.04, 0.62, 0.23, 0.98] }}
          >
            <ExpandMoreIcon />
          </QuestionToggleIcon>
        </Question>
        <Answer
          variants={{
            open: { opacity: 1, height: "auto", marginTop: "16px", display: "block" },
            collapsed: { opacity: 0, height: 0, marginTop: "0px", display: "none" }
          }}
          initial="collapsed"
          animate={activeQuestionIndex === index ? "open" : "collapsed"}
          transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
        >
          {faq.answer}
        </Answer>
      </Faq>
    );

    if (index % 2 === 0) faqCol1.push(renderedFaq);
    else faqCol2.push(renderedFaq);

    return null;
  });
  return (
    <PrimaryBackgroundContainer>
      <ContentWithPadding>
        <HeadingContainer>
          <Heading>{heading}</Heading>
        </HeadingContainer>
        <FaqsContainer>
          <FaqsColumn>{faqCol1}</FaqsColumn>
          <FaqsColumn>{faqCol2}</FaqsColumn>
        </FaqsContainer>
      </ContentWithPadding>
    </PrimaryBackgroundContainer>
  );
};
